import { useState, useEffect } from 'react';
import {
    Box, Grid, CardContent, Fab, Typography, BoxProps
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import Icon from '../../../../components/icon';

export default function Index() {
    const navigate = useNavigate();
    const [nik, setNik] = useState("");
    const [wo, setWo] = useState("");

    useEffect(() => {
        const storedNik = localStorage.getItem("NIK") || "-";
        const storedWo = localStorage.getItem("WO") || "-";
        setNik(storedNik);
        setWo(storedWo);
    }, []);

    const handleClick = async (id: any) => {
        window.localStorage.setItem('wo_proses_id', id)
        navigate('/mm/penggunaan-barang/tambah-penggunaan/')
    }

    return (
        <Box sx={{ width: '100%' }}>
            {/* wrapper sudah di MainLayout (public-inner). Di sini kita hanya atur grid */}
            <Grid
                container
                spacing={2}
                sx={{
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                }}
            >
                {/* Header row */}
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                        <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                            <Icon icon='mdi:arrow-left' />
                            Kembali
                        </Fab>
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                        <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant='h6'>NIK : {nik}</Typography>
                            <Typography variant='h6'>WO : {wo}</Typography>
                            <Typography variant='h6'></Typography>
                        </CardContent>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                        <CardContent sx={{ display: "flex", justifyContent: "flex-start" }}>
                            <Grid container spacing={2} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                                <Grid item xs={12} sm={6} md={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box
                                        sx={{
                                            p: 2,
                                            border: '1px solid grey',
                                            borderRadius: 1,
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: '100%',
                                            boxSizing: 'border-box',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() => handleClick('')}
                                    >
                                        <Typography variant='h6'>Lain-Lain</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}
